import { getApiWrapper, postApiWrapper,getRequest } from "./wrapper";
export const getGautrasList = async () => {
    const url = `https://demomeghwal.merasamaj.app/gautras`;
    console.log(url);
    const result = await getRequest(url);
    console.log(result);
    return result.data.gautras;
  }
